import styles from "./editandcreate.module.css";
import React, { useState, useEffect } from 'react';

export const VegNonVegToggle = ({ value, onChange, types, disabled = false }) => {
  // Direct ID approach - most reliable
  const isVeg = value === 1;
  
  console.log("Toggle state - isVeg:", isVeg, "value:", value);

  const handleToggle = () => {
    if (disabled) return;
    
    const newValue = isVeg ? 2 : 1;
    console.log("Toggling from", value, "to", newValue);
    onChange(newValue);
  };

  // Set default to Vegetarian (1) if no value
  useEffect(() => {
    if (value === undefined || value === null || value === '') {
      console.log("Setting default value to 1");
      onChange(1);
    }
  }, [value, onChange]);

  return (
    <div className={styles.toggleContainer}>      
      <div 
        className={`${styles.toggleWrapper} ${isVeg ? styles.veg : styles.nonVeg} ${disabled ? styles.disabled : ''}`}
        onClick={handleToggle}
      >
        <div className={styles.toggleTrack}>
          <div className={`${styles.toggleSlider} ${isVeg ? styles.slideLeft : styles.slideRight}`}>
            <span className={styles.toggleText}>
              {isVeg ? 'VEG' : 'NON-VEG'}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};